import React from 'react';

import Well from './reusable/well';
import Alert from './reusable/alert';
import Table from './reusable/table';
import Flyout from './reusable/flyout';

import {
  alertPropsData,
  tablePropsData,
  flyerPropsData,
} from '../static/static';

const headers = ['property', 'type', 'required', 'default', 'description'];

export default class ComponentLibrary extends React.Component {
  render() {
    return (
      <div className="react-component-library">
        {this.renderAlertWell()}
        {this.renderTableWell()}
        {this.renderFlyoutWell()}
      </div>
    );
  }

  renderAlertWell = () => {
    return (
      <Well>
        <h2>Alerts</h2>
        <Alert
          handleCloseAlert={() => {}}
          message="I'm a success alert!"
          type="success"
        />
        <Alert
          handleCloseAlert={() => {}}
          message="I'm a failure alert!"
          type="failure"
        />
        <Table
          fancy
          headers={headers}
          data={alertPropsData}
        />
      </Well>
    );
  }

  renderTableWell = () => {
    const exampleHeaders = ['Heading1', 'Heading2', 'Heading3'];
    const data = [
      { Heading1: 'Something here', Heading2: 'Something here', Heading3: 'Something here' },
      { Heading1: 'Something here', Heading2: 'Something here', Heading3: 'Something here' },
      { Heading1: 'Something here', Heading2: 'Something here', Heading3: 'Something here' },
    ];
    return (
      <Well>
        <h2>Tables</h2>
        <Table
          headers={exampleHeaders}
          data={data}
          fancy
        />
        <Table
          headers={exampleHeaders}
          data={data}
        />
        <Table
          headers={headers}
          data={tablePropsData}
          fancy
        />
      </Well>
    );
  }

  renderFlyoutWell = () => {
    return (
      <Well>
        <h2>Flyouts</h2>
        <a
          href="#"
          className="btn btn-primary btn-large flyout-opener"
          onClick={this.handleOpenFlyout}
        >
          Open Flyout
        </a>
        {this.renderFlyout()}
        <Table
          headers={headers}
          data={flyerPropsData}
          fancy
        />
        <div className="note">
          Note: This component is currently controlled with jQuery&apos;s toggleClass method.
        </div>
      </Well>
    );
  }

  renderFlyout = () => {
    return (
      <Flyout
        title="My Amazing Flyout"
        handleCloseFlyout={this.handleCloseFlyout}
      />
    );
  }

  handleOpenFlyout = (e: any) => {
    e.preventDefault();
    $('.flyout').toggleClass('open');
  }

  handleCloseFlyout = () => {
    $('.flyout').toggleClass('open');
  }
}
